import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import CellContent from 'modules/employees/pages/ImportContractsPage/components/ImportTable/Content/CellContent'
import {
  ContractActions,
  ContractStatus,
} from 'modules/employees/pages/ImportContractsPage/components/ImportTable/Content/constants'
import type { ImportedContract } from 'modules/employees/pages/ImportContractsPage/components/ImportTable/Content/types'

interface Props {
  contract: ImportedContract
  attribute: string
}

// FIXME: proper InvalidValue handle
interface InvalidValue {
  value: unknown
}

function isInvalidValue(obj: unknown): obj is InvalidValue {
  return typeof obj === 'object' && obj !== null && 'value' in obj
}

const BasicCellContent = ({ contract, attribute }: Props) => {
  const errored = contract.status === ContractStatus.errored
  const ready = contract.status === ContractStatus.ready
  const conflicted = contract.status === ContractStatus.conflicted
  const attributeValue = contract[attribute]
  const value = isInvalidValue(attributeValue) ? attributeValue.value : attributeValue
  const printableValue = value ? String(value) : ''

  const messageContainer = errored || conflicted ? contract.errors : contract.warnings

  const message =
    messageContainer && messageContainer[attribute] ? String(messageContainer[attribute]) : ''
  const empty = isEmpty(messageContainer)
  const ok = empty || ready || !message
  const updated = contract.modified_keys.updated.includes(attribute)
  const removed = contract.modified_keys.removed.includes(attribute)
  const modified = contract.type != ContractActions.new && (updated || removed)

  return (
    <CellContent
      value={printableValue}
      message={message}
      modified={modified}
      errored={errored}
      ok={ok}
    />
  )
}

export default observer(BasicCellContent)
